var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal modal--setting modal-setting"},[_c('div',{staticClass:"modal-setting__setting"},[_c('form-settings',{attrs:{"settings":_vm.settings}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }